<template>
  <v-container class="success-message">
    <v-row>
      <v-col cols="7">
        <div class="d-flex align-center">
          <div class="d-flex align-start">
            <img alt="Successful submit" src="@/assets/img/success-icon.svg" class="mr-8" />
          </div>
          <div class="message-body">
            <slot>
              <h3>Thank you for submitting your interest for deals on our platform.</h3>
              <p>Our team will be in touch shortly.</p>
            </slot>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'success-message'
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
.success-message {
  background: #fffde6;
  padding: 80px;
  position: relative;
}
h3 {
  color: $text-primary;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  font-family: $header-font;
  margin-bottom: 10px;
}
.message-body {
  display: inline-block;
  p {
    font-size: 18px;
    color: #4a4a4a;
  }
}
</style>
